module.exports = __webpack_public_path__ + "img/10014.f1784012.jpg";